import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "w-full flex flex-wrap" }
const _hoisted_3 = { class: "w-10/12 pr-2" }
const _hoisted_4 = { class: "w-1/12" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Carregar ")
const _hoisted_6 = { class: "w-1/12 pl-1" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Salvar ")
const _hoisted_8 = { class: "w-full pt-2" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" * Selecione um site e clique em \"Carregar\" para buscar os subgrupos pertecentes")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" * Somente os subgrupos selecionados vão aparecer no site da transparência ")

import { ref, onMounted } from 'vue'
import { useSites, useSubgrupos, useSiteSubgrupos } from '@/store'
import {
  NSelect,
  useMessage,
  NButton,
  NTransfer,
  useLoadingBar,
  NAlert,
} from 'naive-ui'
import {
  SaveOutline as SaveIcon,
  DownloadOutline as DownloadIcon,
} from '@vicons/ionicons5'
import { API } from '@/api/api'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const sites = useSites()
const subgrupos = useSubgrupos()
const siteSubgrupos = useSiteSubgrupos()
const sitesOptions = ref([])
const subgruposOptions = ref([])
const message = useMessage()
const subgruposSelected = ref<any[]>([])
const loadingBar = useLoadingBar()
const isLoading = ref<boolean>(false)
const formRef = ref({
  id_site: null as any,
  id_subgrupo: null as any,
  id_situacao: null as any,
  search: null,
  year: null as any,
})

async function fetchSubgruposFromSite() {
  if (formRef.value.id_site == null) {
    message.warning('Selecione um site...')
    return
  }
  loadingBar.start()
  await siteSubgrupos.fetchBySite(formRef.value.id_site)
  subgruposSelected.value = siteSubgrupos.data.map(
    (subgrupo) => subgrupo.id_subgrupo
  )
  loadingBar.finish()
}

async function save() {
  try {
    isLoading.value = true
    const data = {
      subgrupos: subgruposSelected.value,
      id_site: formRef.value.id_site,
    }

    const response = await API().post(`/dashboard/site-subgrupos`, data)

    if (response.status === 200) {
      message.success('Subgrupos do site foram atualizados com sucesso!')
    } else {
      message.error(
        'Erro ao cadastrar site, verifique se os dados estão corretos e tente novamente mais tarde'
      )
    }
  } catch (error) {
    console.error(error)
    message.error(
      'Erro interno - Tente novamente mais tarde e contate o suporte.'
    )
  } finally {
    isLoading.value = false
  }
}

onMounted(async () => {
  loadingBar.start()
  await Promise.all([subgrupos.fetch(true), sites.fetch(true)])
  sitesOptions.value = sites.data.map((site: any) => ({
    label: `${site.id} - ${site.nome}`,
    value: site.id,
  }))
  subgruposOptions.value = subgrupos.data.map((subgrupo: any) => ({
    label: subgrupo.titulo,
    value: subgrupo.id,
  }))
  loadingBar.finish()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(NSelect), {
          value: formRef.value.id_site,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formRef.value.id_site) = $event)),
          options: sitesOptions.value,
          placeholder: "Site",
          class: "w-full",
          filterable: ""
        }, null, 8, ["value", "options"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(NButton), {
          type: "info",
          class: "w-full",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (fetchSubgruposFromSite()))
        }, {
          icon: _withCtx(() => [
            _createVNode(_unref(DownloadIcon))
          ]),
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_unref(NButton), {
          type: "success",
          class: "w-full",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (save()))
        }, {
          icon: _withCtx(() => [
            _createVNode(_unref(SaveIcon))
          ]),
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_unref(NAlert), {
        title: "Aviso",
        type: "info",
        class: "mb-2"
      }, {
        default: _withCtx(() => [
          _hoisted_9,
          _hoisted_10,
          _hoisted_11
        ]),
        _: 1
      }),
      (formRef.value.id_site)
        ? (_openBlock(), _createBlock(_unref(NTransfer), {
            key: 0,
            class: "w-full h-screen",
            ref: "transfer",
            value: subgruposSelected.value,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((subgruposSelected).value = $event)),
            options: subgruposOptions.value,
            "source-title": "Subgrupos",
            "target-title": "Subgrupos selecionados",
            size: "large"
          }, null, 8, ["value", "options"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})